module.exports = __webpack_public_path__ + "static/media/voluntariado.87a2a6b2.png";